module.exports = __webpack_public_path__ + "lu.f8137a63.svg";